import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import Form from '../common/Form'
import InputContainer from '../../containers/common/InputContainer'
import { Option } from '../common/Select'
import SelectContainer from '../../containers/common/SelectContainer'
import { Spin } from '../common/Ant'
import Button from '../common/Button'
import CancelButton from '../common/CancelButton'
import Divider from '../common/Divider'
import FormError from '../common/FormError'
import { required } from '../../utils/validators'
import { COUNTRIES, MODEM_COUNTRIES } from '../../constants'

const EditModemTypeForm = props => {
  const {
    handleSubmit,
    submitting,
    error,
    submitAction,
    isModemTypeLoading,
    carriers,
  } = props

  const submit = handleSubmit(submitAction)
  return isModemTypeLoading ? (
    <Spin size="large" className="w-100 center mv5" />
  ) : (
    <section className="EditModemTypeForm">
      <Form onSubmit={submit}>
        <div className="flex-ns">
          <Field
            name="name"
            type="text"
            component={InputContainer}
            label="Name"
            validate={[required]}
            className="w-100"
          />
        </div>
        <div className="flex-ns">
          <Field
            name="carrierIds"
            component={SelectContainer}
            label="Carriers"
            mode="multiple"
            placeholder="Select supported carriers"
            className="mr3-ns w-50-ns"
            filterable
          >
            {carriers.map(x => (
              <Option value={x.id} key={x.id}>
                {x.name}
              </Option>
            ))}
          </Field>
          <Field
            name="countries"
            component={SelectContainer}
            label="Countries"
            mode="multiple"
            placeholder="Select supported countries"
            className="w-50-ns"
            filterable
          >
            {MODEM_COUNTRIES.map(code => (
              <Option value={code} key={code}>
                {COUNTRIES[code] || code}
              </Option>
            ))}
          </Field>
        </div>
        <Divider />
        <FormError error={error} />
        <div className="flex justify-between">
          <CancelButton defaultLocation="/inventory/all/modems" />
          <Button text="Submit" type="submit" submitting={submitting} />
        </div>
      </Form>
    </section>
  )
}

EditModemTypeForm.propTypes = {
  submitAction: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  isModemTypeLoading: PropTypes.bool,
  carriers: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.string,
}

export default reduxForm({ form: 'EditModemTypeForm' })(EditModemTypeForm)
